// 流行歌曲分组数据
// ai梳理歌曲顺序命令：将以下按照拼音顺序进行排序 ，输出的结果按照'xxxx',(换行)'xxxx',换行的格式来输出。
// 曲目输出顺序按照歌名先中文后英文，意思是，首先输出按照拼音排序的中文歌，然后输出按照英文字母表排序的英文歌。
// 如果英文歌歌名如果是全小写，则修改为首字母大写再输出，比如boom就修改为Boom输出。
// 不需要序号，不需要其他注释  。
export const groupedPopularSongs = {
  "A": [
    "阿楚姑娘",
    "哎呀呀",
    "爱",
    "爱的人",
    "爱错",
    "爱你",
    "暗香",
    "Always Online",
    "All Through The Night"
  ],
  "B": [
    "宝贝",
    "暴风少年",
    "不二臣",
    "不潮不用花钱",
    "不得不爱",
    "不能说的秘密",
    "不眠之夜",
    "不为谁而作的歌",
    "不爱我就拉倒",
    "不遗憾",
    "不要忘记我爱你",
    "不在",
    "不值得",
    "本草纲目",
    "病变",
    "Bedroom",
    "Boom沙卡拉卡",
    "Brave Heart",
    "百万个吻",
    "白马入芦花"
  ],
  "C": [
    "彩虹",
    "曹操",
    "成都",
    "成全",
    "宠爱",
    "吵架歌",
    "匆匆那年",
    "从前慢",
    "从前说",
    "凑热闹",
    "敕勒歌",
    "耻辱柱",
    "Christmas List"
  ],
  "D": [
    "等",
    "达尔文",
    "大鱼",
    "大眠",
    "倒数",
    "弹唱",
    "当你",
    "当你老了",
    "等到世界颠倒",
    "第一天",
    "断点",
    "对面的女孩看过来",
    "对不起我爱你",
    "低空飞行",
    "第三人称",
    "等温相拥",
    "多幸运",
    "多远都要在一起",
    "到不了",
    "兜圈",
    "对的时间点"
  ],
  "E": [
    "恶作剧"
  ],
  "F": [
    "飞鸟和蝉",
    "飞机场",
    "非酋",
    "逢他逢我",
    "父亲写的散文诗",
    "蜂鸟",
    "负重一万斤长大",
    "反正",
    "枫"
  ],
  "G": [
    "告白",
    "告白气球",
    "干物女",
    "鸽子",
    "耿",
    "恭喜发财",
    "给我一个理由忘记",
    "给我一首歌的时间",
    "关于你的情歌",
    "关键词",
    "Got It",
    "给我一个念"
  ],
  "H": [
    "寒鸦少年",
    "花海",
    "海芋恋",
    "黑武士",
    "红豆",
    "红玫瑰",
    "虹之间",
    "胡广生",
    "呼吸决定",
    "缓缓",
    "黄昏晓",
    "后会无期",
    "会有那么一天",
    "好运来",
    "荷塘月色",
    "花好月圆夜",
    "花落时相遇",
    "荒漠上行走",
    "History"
  ],
  "I": [
    "IF YOU"
  ],
  "J": [
    "嘉宾",
    "假装",
    "假如爱有天意",
    "姬和不如",
    "戒烟",
    "江南",
    "交换余生",
    "剑魂",
    "今夜有雨",
    "开始懂了",
    "就是爱你",
    "记念"
  ],
  "K": [
    "空白格",
    "靠近",
    "可乐",
    "刻在我心底的名字",
    "克卜勒",
    "苦茶",
    "可有可无",
    "快乐女孩"
  ],
  "L": [
    "拉过勾的",
    "蕾拉",
    "泪桥",
    "莉莉安",
    "连名带姓",
    "恋爱ing",
    "浪漫手机",
    "浪漫血液",
    "流浪记",
    "裂缝中的阳光",
    "笼",
    "鹿港小镇",
    "落叶归根",
    "落在生命里的光"
  ],
  "M": [
    "梦一场",
    "没离开过",
    "迷宫",
    "明明",
    "命运",
    "明天我要去见你",
    "魔鬼中的天使",
    "美人鱼",
    "茉莉雨",
    "漠河舞厅",
    "骂不醒",
    "Melody",
    "美丽的神话",
    "Mojito"
  ],
  "N": [
    "逆光",
    "女孩",
    "南风过隙",
    "霓虹甜心",
    "年轮",
    "那栋楼",
    "那女孩对我说",
    "那些你很冒险的梦",
    "你的名字",
    "你不是一个人",
    "你好不好",
    "你是我的风景",
    "你呀你呀",
    "浓缩蓝鲸",
    "南山南",
    "你是我的玫瑰花",
    "你只是经过"
  ],
  "O": [],
  "P": [
    "陪你度过漫长岁月",
    "蒲公英的约定",
    "普通朋友",
    "偏爱"
  ],
  "Q": [
    "青鸟",
    "青火",
    "青柠",
    "清空",
    "情歌",
    "起风了",
    "千禧",
    "奇迹再现",
    "如愿",
    "茜さす",
    "去北极忘记你"
  ],
  "R": [
    "热爱105°的你",
    "热恋夏季",
    "热铁皮房顶的夏天",
    "人是",
    "人世间",
    "如何",
    "如果声音不记得",
    "如果突然想起我",
    "如果我们不曾相遇",
    "如果你也听说",
    "如果没有你",
    "如果雨之后"
  ],
  "S": [
    "杀死那个石家庄人",
    "杀手",
    "圣诞结",
    "生生",
    "输了你赢了世界又如何",
    "是你",
    "是你想成为的大人吗",
    "是妈妈是女儿",
    "素颜",
    "苏州河",
    "说好的幸福呢",
    "Simon",
    "Sugar",
    "苏公堤",
    "Still With You"
  ],
  "T": [
    "太阳",
    "天后",
    "天黑黑",
    "天龙八部之宿敌",
    "天外来物",
    "天真有邪",
    "天空之外",
    "他不懂",
    "他的爱",
    "太聪明",
    "天天",
    "停停",
    "同花顺",
    "褪黑素",
    "The Joker And The Queen",
    "The Show",
    "Too Bad"
  ],
  "U": [],
  "V": [],
  "W": [
    "晚安",
    "晚婚",
    "忘与记",
    "勿忘",
    "屋顶",
    "温柔",
    "王妃",
    "唯一",
    "无与伦比的美丽",
    "我还年轻我还年轻",
    "我会等",
    "我和你",
    "我好像在哪见过你",
    "我落泪情绪零碎",
    "我可以",
    "我的果汁分你一半",
    "我们",
    "我们俩",
    "我管你",
    "我要你",
    "我在时间尽头等你",
    "Wonderful U",
    "万物不如你",
    "未出现传闻",
    "我的女人",
    "我的秘密"
  ],
  "X": [
    "小孩",
    "小半",
    "小卦",
    "小精灵",
    "小酒窝",
    "小美满",
    "小情歌",
    "小跳蛙",
    "小城夏天",
    "小星星",
    "小幸运",
    "小小",
    "小宇",
    "夏天",
    "夏夜最后的烟火",
    "夏至未至",
    "下雨了",
    "小雨",
    "鲜花",
    "霞光",
    "消散对白",
    "像晴天像雨天",
    "心痛无医",
    "心墙",
    "心绪缠绕",
    "形容",
    "星河水手",
    "陷阱",
    "写给黄淮",
    "西柚",
    "喜欢你",
    "学不会",
    "谢幕",
    "雪落下的声音",
    "想见你想见你想见你",
    "想自由",
    "想去海边",
    "小哪吒",
    "笑忘书",
    "幸福拍手歌"
  ],
  "Y": [
    "雅俗共赏",
    "阳光宅男",
    "也罢",
    "亿万分之一",
    "野子",
    "燕窝",
    "一笑倾城",
    "一吻天荒",
    "一生等你",
    "要抱抱",
    "勇敢爱",
    "勇气",
    "友情卡片",
    "有点甜",
    "有没有",
    "有些",
    "有幸",
    "有我呢",
    "永不失联的爱",
    "月牙湾",
    "要不然我们就这样一万年",
    "遇见",
    "遇到",
    "雨爱",
    "愿与愁",
    "越过森林",
    "云边书坊",
    "云与海",
    "云海里的帆",
    "You Raise Me Up",
    "夜南京",
    "夜的第七章"
  ],
  "Z": [
    "在加纳共和国离婚",
    "这世界那么多人",
    "这是我一生中最勇敢的瞬间",
    "这条小鱼在乎",
    "直到遇见了你我只喜欢你",
    "直到世界尽头",
    "怎么了",
    "致你",
    "知足",
    "中毒",
    "着迷",
    "着魔",
    "追光者",
    "指纹",
    "只对你有感觉",
    "只对你说",
    "左手指月",
    "走马",
    "走走",
    "租购",
    "在意识里过一生",
    "追梦赤子心"
  ]
};

// 古风/国风歌曲分组数据
export const groupedChineseStyleSongs = {
  'A': [],
  'B': [
    '壁上观',
    '步戏',
    '不染',
    '不谓侠',
  ],
  'C': [
    '参商',
    '长生诀',
    '赤伶',
    '春不晚',
  ],
  'D': [
    '典狱司',
    '断钗',
    '东风志',
  ],
  'F': [
    '飞花调',
    '凤凰于飞',
    '浮生未歇',
  ],
  'G': [
    '给某某',
    '光亮',
  ],
  'H': [
    '红昭愿',
    '湖心亭',
    '贺新婚',
  ],
  'J': [
    '九九八十一',
    '九万字',
    '惊鸿一面',
    '江山歌行',
    '江湖之间',
    '借月',
    '君临天下',
    '酒家',
    '霁夜茶',
  ],
  'M': [
    '梦回花事了',
    '梦回还',
    '明月天涯',
  ],
  'N': [
    '那年年少',
    '凝眸'
  ],
  'Q': [
    '芊芊',
    '千秋迭梦',
    '湫之灵',
    '牵丝戏',
    '倾君',
    '青花瓷',
    '青玉恋',
    '青城山下白素贞',
  ],
  'R': [
    '汝南',
    '如寄',
    '若梦',
  ],
  'S': [
    '三拜红尘凉',
    '三国恋',
    '十年人间',
    '上那',
    '是风动',
  ],
  'T': [
    '桃花诺',
    '桃花笑',
    '棠梨煎雪',
    '天下（DJ版）',
    '同道殊途',
  ],
  'W': [
    '晚夜微雨问海棠',
    '忘尘如羡',
    '问情',
    '我的一个道姑朋友',
    '我叫长安，你叫故里',
  ],
  'X': [],
  'Y': [
    '一拜天地',
    '遗世兼葭',
    '月光',
    '鸳鸯戏',
  ],
  'Z': []
};